var _path, _path2, _circle, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 291,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m118 125c-2 0-4 2-4 4v41c0 2 2 4 4 4h33v51s-7 3-28 3c-24 0-57-9-57-83 0-74 35-83 68-83 29 0 41 5 49 7 2 1 5-2 5-4l9-40c0-1 0-2-2-3-3-2-22-13-71-13-57 0-113 23-113 139 0 115 66 132 121 132 46 0 74-19 74-19 1-1 1-2 1-3v-129c0-2-2-4-4-4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m635 23c0-2-2-4-4-4h-47c-2 0-4 2-4 4 0 0 0 91 0 91h-74v-91c0-2-2-4-4-4h-47c-2 0-4 2-4 4v247c0 2 2 4 4 4h47c2 0 4-2 4-4v-106h74l0 106c0 2 2 4 4 4h47c2 0 4-2 4-4v-247"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 56,
    r: 31
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m288 104c0-2-2-4-4-4h-47c-2 0-4 2-4 4v164c0 5 3 6 7 6h43c5 0 6-2 6-6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m768 101c-2 0-4 2-4 4v121s-12 9-29 9c-17 0-21-8-21-24v-106c0-2-2-4-4-4h-47c-2 0-4 2-4 4v114c0 49 27 61 65 61 31 0 56-17 56-17s1 9 2 10c1 1 2 2 3 2l30 0c2 0 4-2 4-4l0-166c0-2-2-4-4-4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m926 236c-20 0-29-9-29-9v-79s11-7 24-8c17-2 33 4 33 44 0 43-5 52-29 52zm-27-129v-84c0-2-2-4-4-4h-47c-2 0-4 2-4 4v247c0 2 2 4 4 4h33c1 0 3-1 3-2 1-1 2-11 2-11s19 19 56 19c43 0 68-22 68-98s-39-86-66-86c-27 0-45 12-45 12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m389 100 0-47c0-2-1-3-3-3h-49c-2 0-3 1-3 4v49s-24 6-26 6c-2 1-3 2-3 4v31c0 2 2 4 4 4h25v73c0 55 38 60 64 60 12 0 26-4 28-5 1-1 2-2 2-4l0-33c0-2-2-4-4-4-2 0-7 1-13 1-17 0-23-8-23-19 0-11 0-69 0-69h35c2 0 4-2 4-4v-40c0-2-2-4-4-4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubbig);
export default __webpack_public_path__ + "static/media/githubbig.d5961fcdceb412efba9a768c3a727a8f.svg";
export { ForwardRef as ReactComponent };